import { useEffect, useRef, useState } from "react";
import styles from "../../ProductsByCategory.module.scss";

export const SubCategoriesHorizontalList = ({ subSubCategories, onChangeSelection, activeSection }) => {
  const [active, setActive] = useState(0);
  const containerRef = useRef(null);
  const buttonRefs = useRef({});

  useEffect(() => {
    if (activeSection !== undefined && activeSection !== active) {
      setActive(activeSection);
      
      // Auto-scroll to active button
      const activeButton = buttonRefs.current[activeSection];
      const container = containerRef.current;
      
      if (activeButton && container) {
        const containerWidth = container.offsetWidth;
        const buttonLeft = activeButton.offsetLeft;
        const buttonWidth = activeButton.offsetWidth;
        const scrollLeft = container.scrollLeft;
        
        // Calculate if button is out of view
        const buttonRight = buttonLeft + buttonWidth;
        const visibleRight = scrollLeft + containerWidth;
        
        if (buttonLeft < scrollLeft) {
          // Button is to the left, scroll left
          container.scrollTo({
            left: buttonLeft - 20,
            behavior: 'smooth'
          });
        } else if (buttonRight > visibleRight) {
          // Button is to the right, scroll right
          container.scrollTo({
            left: buttonRight - containerWidth + 20,
            behavior: 'smooth'
          });
        }
      }
    }
  }, [activeSection, active]);

  if (window.innerWidth > 576) {
    return null;
  }

  return (
    <div className={styles.category_horizontal_filter} ref={containerRef}>
        {subSubCategories.map((subcategory, index) => (
            <button
                key={subcategory.id}
                ref={(el) => (buttonRefs.current[index] = el)}
                onClick={() => {
                  setActive(index);
                  onChangeSelection(index);
                }}
                className={active === index ? styles.active : ''}
            >
                {subcategory.name}
            </button>
        ))}
    </div>
  )
}